module.exports = __webpack_public_path__ + "img/layer_down.8dedf51e.svg";